export default __webpack_public_path__ + "0eefb3a49d9e019dd0309a8d46c84b07.svg";